import { omit } from "lodash";
import API from "@irati/utils/services/API";
import endpoints from "../endpoints";
import getTenantFromPathHelper from "../helpers/getTenantFromPath";
import tenantErrorHandler from "./errors/tenantErrorHandler";
import parseTenant from "../helpers/parseTenant";
var TenantService = /** @class */ (function () {
    function TenantService() {
        var _this = this;
        // legacy support, expose on service
        this.getTenantFromPath = function () { return getTenantFromPathHelper(); };
        this.searchTenants = function (search, limit, config) {
            if (limit === void 0) { limit = 10; }
            if (config === void 0) { config = {}; }
            config.params = {
                q: search,
                limit: limit
            };
            return API.get(endpoints.tenants(), config)
                .then(function (response) { return response.data; })
                .catch(tenantErrorHandler);
        };
        this.getTenantBySubdomain = function (subdomain, config) {
            if (config === void 0) { config = {}; }
            var tenantSubdomain = subdomain || _this.getTenantFromPath();
            return API.get(endpoints.tenants() + "/subdomain/" + tenantSubdomain, config)
                .catch(tenantErrorHandler)
                .then(function (res) { return parseTenant(res.data, config); });
        };
        this.createTenant = function (data, config) {
            if (config === void 0) { config = {}; }
            return API.post(endpoints.tenants(), data, config)
                .catch(tenantErrorHandler)
                .then(function (res) { return parseTenant(res.data, config); });
        };
        this.getTenant = function (uuid, config) {
            if (config === void 0) { config = {}; }
            return API.get(endpoints.tenants() + "/" + uuid, config)
                .catch(tenantErrorHandler)
                .then(function (res) { return parseTenant(res.data, config); });
        };
        this.updateTenant = function (userTenant, data, config) {
            if (config === void 0) { config = {}; }
            var url = endpoints.tenants() + "/" + userTenant.uuid;
            var tenant = _this.parseTenantForPut(data);
            return API.put(url, tenant, userTenant.Etag)
                .catch(tenantErrorHandler)
                .then(function (res) { return parseTenant(res.data, config); });
        };
        this.parseTenantForPut = function (tenant) {
            tenant.teams = undefined;
            return omit(tenant, "id", "uuid");
        };
        this.requestTenant = function (tenant, options) {
            if (options === void 0) { options = {}; }
            if (tenant.uuid && !options.unAuth) {
                return _this.getTenant(tenant.uuid, options);
            }
            if (tenant.subdomain) {
                return _this.getTenantBySubdomain(tenant.subdomain, options);
            }
            return Promise.reject("[RequestTenant]: No tenant identifier given");
        };
        this.getSubdomainHistory = function (tenantId, options) {
            if (options === void 0) { options = {}; }
            return API.get("" + endpoints.subdomainHistory(tenantId), options)
                .then(function (res) { return res.data; })
                .catch(tenantErrorHandler);
        };
    }
    return TenantService;
}());
var service = new TenantService();
export var getTenantFromPath = service.getTenantFromPath;
export var searchTenants = service.searchTenants;
export var getTenantBySubdomain = service.getTenantBySubdomain;
export var createTenant = service.createTenant;
export var getTenant = service.getTenant;
export var updateTenant = service.updateTenant;
export var parseTenantForPut = service.parseTenantForPut;
export var requestTenant = service.requestTenant;
export var getSubdomainHistory = service.getSubdomainHistory;
export default service;
